import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTES, URL_PARAMS, USER_TYPE } from "../constants";
import { AuthService } from "./auth.service";
import { UtilityService } from "./utility.service";
import {SessionService} from "./session.service";

@Injectable({
	providedIn: "root"
})
export class SignupGuardService {

	constructor(
		private authService: AuthService,
		private sessionService: SessionService,
		private router: Router,
		private utilityService: UtilityService
	) { }

	/**
	 * It will check if user is authenticated or not.
	 * Return true if authenticated otherwise false.
	 */
	canActivate(): boolean {
		const params = this.utilityService.getParamsFromEncodedUrl( window.location.href );
		if(params["authToken"]){
			return true;
		} else {
			if ( !this.isAccountActivation() ) {
				if ( this.sessionService.isAuthenticated() ) {
					this.redirectToUserDashboard()
					return false;
				} else if( this.sessionService.remainingRefreshTokenTime > 600 && this.sessionService.remainingAccessTokenTime < 60 ) {
					this.authService.refreshToken().subscribe((res) => {
						this.redirectToUserDashboard();
						return false;
					})
				}
				return true;
			}
			return true;
		}
	}

	redirectToUserDashboard() {
		if ( this.sessionService.userType === USER_TYPE.BUYER ) {
			this.router.navigate( [ ROUTES.BUYER_ROUTE ] );
		} else {
			this.router.navigate( [ ROUTES.SUPPLIER_ROUTE ] );
		}
	}

	/**
	 * Check if url is for account-activation
	 */
	isAccountActivation() {
		const params = this.utilityService.getParamsFromEncodedUrl( window.location.href );
		if ( params && params[URL_PARAMS.EMAIL] && params[URL_PARAMS.CODE] && params[URL_PARAMS.TYPE] ) {
			this.utilityService.clearStorageAndCookies();
			return true;
		}
		return false;
	}
}
